import {formatUserProperties} from 'common/util/format-property';
import {MPProperties} from 'common/constants';
import {checkProfileExists, getUserPropertiesFromApiResult} from 'common/report/util/profile/utils';
import type {
  AliasesQueryResult,
  EngageQueryResult,
  FormattedAliasesResult,
  FormattedEngageResult,
  FormattedMessagesResult,
} from 'common/report/util/profile/types';

export function engageResultFormatter(res: EngageQueryResult, dataGroupId, timezone): FormattedEngageResult {
  const {error, results} = res;
  if (error || results.status !== `ok`) {
    return {
      error: true,
      results: null,
      messages: null,
      profileExists: false,
    };
  }

  const properties = getUserPropertiesFromApiResult(results);

  const formattedProperties = formatUserProperties(properties, {timezone, dataGroupId});
  const messages = properties[MPProperties.Campaigns] as string[];
  const profileExists = checkProfileExists(results);

  return {
    error: false,
    results: formattedProperties,
    profileExists,
    messages,
  };
}

export function messagesResultFormatter(result: any): FormattedMessagesResult {
  const {results, error} = result;
  if (error || results?.error) {
    return {
      error: true,
      results: null,
    };
  } else {
    return {
      error,
      results: results.map((message) => ({
        ...message,
        campaignId: message.campaign_id,
        messageMedia: message.message_media,
      })),
    };
  }
}

export function aliasesResultFormatter(result: AliasesQueryResult): FormattedAliasesResult {
  const {results, error} = result;
  if (!error) {
    const {aliases, resolves_to: resolvesTo} = results;
    return {
      aliases,
      error: false,
      resolvesTo,
    };
  } else {
    return {
      aliases: [],
      error: true,
      resolvesTo: null,
    };
  }
}
